import FadedText from "@components/FadedText";
import { Column, Row } from "@components/Layout";
import { Template } from "@components/Template";
import type { VoidComponent } from "solid-js";
import { CommentWrapper } from "./styled";

const CommentRowTemplate: VoidComponent<{
	even?: boolean;
}> = (props) => {
	return (
		<CommentWrapper even={props.even} padding="20px" gap="30px">
			<Row gap="5px">
				<Column w="max-content">
					<Template w="40px" h="40px" borderRadius="50%" />
				</Column>
				<Column gap="30px">
					<Row justifyContent="space-between" alignItems="center">
						<Template w="150px" h="20px" borderRadius="5px" />
						<Row w="max-content" flexShrink={0}>
							<FadedText fontSize="14px">
								<Row gap="5px">
									<Template w="30px" h="15px" borderRadius="5px" />
								</Row>
							</FadedText>
						</Row>
					</Row>
					<Row gap="10px" alignItems="center">
						<Template w="30px" h="30px" borderRadius="50%" />
						<Template w="80%" h="25px" borderRadius="5px" />
					</Row>
				</Column>
			</Row>
			<Row gap="5px" alignItems="center" justifyContent="space-between">
				<Row w="max-content" gap="5px">
					<button type="button">
						<Template w="30px" h="15px" borderRadius="5px" />
					</button>
					<button type="button">
						<Template w="30px" h="15px" borderRadius="5px" />
					</button>
				</Row>
				<Template w="60px" h="15px" borderRadius="5px" />
			</Row>
		</CommentWrapper>
	);
};
export default CommentRowTemplate;
